module.exports = __webpack_public_path__ + "img/vertical-small-line.92d13be2.svg";